// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-2c1db6fc] {\n  font-weight: 600;\n}\n.method-buttons[data-v-2c1db6fc] {\n  row-gap: 10px;\n}", ""]);
// Exports
module.exports = exports;
